<script lang="ts">
  import { InformationCircleIcon } from "@rgossiaux/svelte-heroicons/outline";
  import RessourcesMenu from "@components/dialog/RessourcesMenu.svelte";
  import { can, Roles } from "@utils/decorators";
  import { Popover } from "@core-ui";
  export let item: any;
  let menu;
  let selectedItem;

  function showContextMenu(e: PointerEvent) {
    menu.show(selectedItem, { x: e.x, y: e.y });
  }

  const restrictedShowContextMenu = can(
    [Roles.DEV, Roles.CONTENT],
    showContextMenu
  );
</script>

<Popover
  triggeredBy={`[data-popover="evidence_${item.id}_label_info"]`}
  class="z-20 text-sm font-light w-80"
  defaultClass="p-0"
  arrow={true}
>
  <div class="grid grid-cols-5">
    <div class="col-span-5 p-4">
      <div class="space-y-2">
        <h3 class="font-semibold text-gray-900 dark:text-white">
          {item.title}
        </h3>
        <p class="text-gray-500 dark:text-gray-500">
          {item.description ? item.description : "No description available"}
        </p>
      </div>
    </div>
  </div>
</Popover>

<RessourcesMenu bind:this={menu} />
<li
  class="py-1"
  on:contextmenu|preventDefault={(e) => {
    selectedItem = item;
    restrictedShowContextMenu(e);
  }}
>
  <div class="flex items-center justify-start gap-3">
    <a
      href={item.url}
      target="_blank"
      class="hover:underline hover:underline-offset-2"
      data-popover={`evidence_${item.id}_label_info`}
    >
      {item.title}
    </a>
    <div class="w-4 h-4">
      <InformationCircleIcon
        class="w-4 h-4"
        data-popover={`evidence_${item.id}_label_info`}
      />
    </div>
  </div>
</li>
